<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 6579 6579"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <circle class="fil0" cx="3290" cy="3290" r="3290" />
   <path class="fil1"
         d="M4036 2458l0 -887c0,-133 -108,-241 -241,-241 -133,0 -241,108 -241,241l0 887 -577 0 0 -887c0,-133 -108,-241 -241,-241 -133,0 -240,108 -240,241l0 887 -530 0 0 1948c0,228 180,410 408,410l651 0 0 433 481 0 0 -433 686 0c229,0 421,-182 421,-410l0 -1948 -577 0z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'GeneralElectricalDevice',
};
</script>

<style scoped>
.fil0 {fill:#56D6D1}
.fil1 {fill:#FEFEFE;fill-rule:nonzero}
</style>
